<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons"
                     @button-click="handlePageHeaderButtonClick" />

        <!-- Claim List Nav -->
        <div v-if="selectedClaim" class="row mb-3">
            <div class="col-sm-3">
                <button type="button"
                        class="btn btn-outline-secondary"
                        :disabled="selectedClaimIndex == 0"
                        @click="handleClaimNavClick(-1)">
                    <i class="fas fa-angle-left"></i>
                </button>
            </div>
            <div class="col-sm-6">
                <div class="text-center">
                    <p class="lead font-weight-bold">{{'Claim ' + selectedClaimIndexDisplay + ' of ' + claimsListCount}}</p>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="float-right">
                    <button type="button"
                            class="btn btn-outline-secondary"
                            :disabled="selectedClaimIndex >= claimsListCount -1"
                            @click="handleClaimNavClick(1)">
                        <i class="fas fa-angle-right"></i>
                    </button>
                </div>
            </div>
        </div>
        <div v-if="selectedClaim && selectedClaimExtraFields" class="row mb-3">
            <!-- Claim overview -->
            <div class="col">
                <h3 class="">Overview</h3>
                <simple-display-grid key="claimOverview"
                                     :columnCount="3"
                                     :inputs="claimOverviewInputsEx"
                                     :values="selectedClaimExtraFields" />
                <div class="row mt-3">
                    <div class="col">
                        <policy-cover-limits />
                    </div>
                    <div class="col">
                        <policy-excess-info />
                    </div>
                    <div class="col">
                        <policy-other-info />
                    </div>
                    <div class="col-2">
                        <claim-notifications-button :claimId="selectedClaim.claimId" />
                    </div>
                </div>
                
                
                <div v-if="selectedClaim.insuranceLineId == 2">
                    <hr />
                    <claim-excess :claimId="claimId" />
                </div>
            </div>
        </div>
        <b-card no-body>
            <b-tabs v-model="tabIndex" card>
                <!-- Overview / Approve -->
                <b-tab title="Overview / Approve" active>

                    <div>


                        <div v-if="selectedClaim" class="row">
                            <!-- Tasks -->
                            <div class="col">
                                <!-- Tasks -->
                                <b-card no-body>
                                    <b-tabs card v-model="tab2Index">
                                        <!-- Update Claim -->
                                        <b-tab title="Update Claim" active>

                                            <div class="form-group row">
                                                <label class="col-sm-4 col-form-label"
                                                       :for="'relatedReference'">
                                                    Related Reference
                                                </label>
                                                <div class="col-sm-8">
                                                    <input type="text"
                                                           class="form-control form-control-sm"
                                                           :id="'relatedReference'"
                                                           :ref="'relatedReference'"
                                                           :placeholder="'Related Reference'"
                                                           v-model="updatedRelatedRef">
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-4 col-form-label"
                                                       :for="'manualStatuses'">
                                                    Available statuses
                                                </label>
                                                <div class="col-sm-8">
                                                    <b-form-select v-model="updatedStatus" :options="manualStatuses" size="sm" class="">
                                                        <template slot="first">
                                                            <option :value="null" disabled>-- Please select an option --</option>
                                                        </template>
                                                    </b-form-select>
                                                </div>
                                            </div>
                                            <transition name="fade">
                                                <div v-if="updatedStatus != null && updatedStatus.id == 1024" class="form-group row">
                                                    <label class="col-sm-4 col-form-label"
                                                           :for="'manualStatuses'">
                                                        Declination reasons
                                                    </label>
                                                    <div class="col-sm-8">
                                                        <b-form-select v-model="selectedDeclinationReason" :options="declinationReasons" size="sm" class="">
                                                            <template slot="first">
                                                                <option :value="null" disabled>-- Please select an option --</option>
                                                            </template>
                                                        </b-form-select>
                                                    </div>
                                                </div>
                                            </transition>
                                            <transition name="fade">
                                                <div class="alert alert-warning">
                                                    <p><i class="fas fa-info-circle mr-2"></i>Warnings:</p>
                                                    <ul v-if="warningPipelineRuleResults && warningPipelineRuleResults.length > 0">
                                                        <li v-for="(res, index) in warningPipelineRuleResults" :key="index">
                                                            {{res.message.body}}
                                                        </li>
                                                    </ul>
                                                    <div v-else class="spinner-border" role="status">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                </div>
                                            </transition>
                                            <transition name="fade">
                                                <div v-if="pipelineRuleResults && pipelineRuleResults.length > 0" class="alert alert-danger">
                                                    <p><i class="fas fa-info-circle mr-2"></i>Unable to update this claim because:</p>
                                                    <ul>
                                                        <li v-for="(res, index) in pipelineRuleResults" :key="index">
                                                            {{res.message.body}}
                                                        </li>
                                                    </ul>
                                                </div>
                                            </transition>
                                            <div class="row">
                                                <div class="col">
                                                    <div class="float-right">
                                                        <button type="button"
                                                                class="btn btn-primary"
                                                                @click="handleUpdateRelatedRefClick()">
                                                            UPDATE CLAIM
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-tab>
                                        <!-- Mark As -->
                                        <b-tab title="Mark As">
                                            <div v-if="claimMessageUncompletedCount && claimMessageUncompletedCount > 0">
                                                <p>There are currently {{claimMessageUncompletedCount}} messages awaiting attention.  Click the Messages Tab above.</p>
                                            </div>
                                            <div v-if="taskOptions2 && taskOptions2.length > 0">
                                                <b-form-group label="Mark As:">
                                                    <b-form-checkbox v-for="option in taskOptions2"
                                                                     v-model="selected"
                                                                     :key="option.id"
                                                                     :value="option.id"
                                                                     name="flavour-3a">
                                                        {{ option.label }}
                                                    </b-form-checkbox>
                                                </b-form-group>
                                                <div class="row mb-2">
                                                    <div class="col">
                                                        <div class="float-right">
                                                            <button type="button"
                                                                    class="btn btn-primary"
                                                                    @click="handleUpdateFlagsClick()">
                                                                Mark As
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="(!(claimMessageUncompletedCount && claimMessageUncompletedCount > 0) && !(taskOptions2 && taskOptions2.length > 0))">
                                                <p>Currently no outstanding tasks!</p>
                                            </div>
                                            <hr />
                                            <p><i class="fas fa-info-circle mr-2"></i>Below is a snapshot of the Task History for this Claim.</p>
                                            <data-list v-if="selectedClaim.taskHistoryDetails" :dataCols="taskHistoryDetailsCols"
                                                       :dataListItems="selectedClaim.taskHistoryDetails"
                                                       :tableClass="'table table-striped table-sm'" />
                                            <div v-else class="spinner-border" role="status">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                        </b-tab>
                                        <!-- Notes -->
                                        <b-tab title="Notes">
                                            <claim-notes />
                                        </b-tab>
                                        <!-- Policy -->
                                        <b-tab title="Policy">
                                            <policy-details />
                                            <!--<window-portal :open="tab2Index == 3">
                                                <policy-details />
                                            </window-portal>-->
                                        </b-tab>
                                        <!-- User -->
                                        <b-tab title="Web User">
                                            <claim-user :userId="selectedClaim.userId" />
                                        </b-tab>
                                    </b-tabs>
                                </b-card>
                            </div>
                        </div>
                    </div>

                    <b-modal id="previewEmailModal" ref="previewEmailModal" title="Email Preview" size="lg" :ok-only="true">
                        <div v-if="emailPreview && emailPreview.messageHtml" class="embed-responsive embed-responsive-16by9">
                            <iframe class="embed-responsive-item"
                                    :src="getBlobURL(emailPreview.messageHtml, 'text/html')"></iframe>
                        </div>
                        <div v-else class="embed-responsive embed-responsive-16by9">
                            <span>Loading...</span>
                        </div>
                    </b-modal>

                    <div v-if="selectedClaim" class="row">
                        <div :class="!isReportPopped ? 'col-6' : 'col-12'" class="mb-5">
                            <div class="row">
                                <div class="col">
                                    <hr />
                                    <collapsible-card-buttons class="float-right mb-2" />
                                </div>
                            </div>
                            <!-- Personal Details -->
                            <collapsible-card>
                                <h3 slot="title">Personal details</h3>

                                <div slot="body">
                                    <div class="row">
                                        <div class="col">
                                            <hr />
                                            <simple-display-grid key="simpleDisplayGrid2"
                                                                 :columnCount="1"
                                                                 :inputs="personalDetailsInputs"
                                                                 :values="selectedClaim" />
                                        </div>
                                    </div>
                                    <div v-if="selectedClaim.insuranceLineId == 1" class="row">
                                        <div class="col">
                                            <p><strong>Last refresh:</strong> {{selectedClaim.claimPolicyLastRefresh}}</p>
                                        </div>
                                        <div class="col">
                                            <div class="float-right">
                                                <button type="button"
                                                        class="btn btn-primary"
                                                        :disabled="!isPolicyholder"
                                                        @click="handleRefreshClaimantClick()">
                                                    REFRESH CLAIMANT
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </collapsible-card>

                            <!-- Claim Details -->
                            <collapsible-card class="mt-3">
                                <h3 slot="title">Claim details</h3>
                                <div slot="body" class="row">
                                    <div class="col">
                                        <hr />
                                        <simple-display-grid key="simpleDisplayGrid6"
                                                             :columnCount="1"
                                                             :inputs="claimDetailsInputs"
                                                             :values="selectedClaim" />
                                    </div>
                                </div>
                            </collapsible-card>

                            <!-- Trip Details -->
                            <collapsible-card class="mt-3">
                                <h3 slot="title">Trip details</h3>
                                <div slot="body" class="row">
                                    <div class="col">
                                        <hr />
                                        <simple-display-grid key="simpleDisplayGrid7"
                                                             :columnCount="1"
                                                             :inputs="tripDetailsInputs"
                                                             :values="selectedClaim" />
                                    </div>
                                </div>
                            </collapsible-card>

                        </div>

                        <!-- Popout -->
                        <div v-show="!isReportPopped" class="col-6 border-left">
                            <!--<div class="make-me-sticky">-->
                            <div>
                                <claim-approve-popout-tabs />

                                <button class="btn btn-sm btn-secondary float-right" @click="handlePopoutClick()"><i class="far fa-clone"></i> Popout</button>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <span>Loading...</span>
                    </div>

                </b-tab>
                <!-- Gadgets -->
                <b-tab title="Gadgets">
                    <div v-if="selectedClaim">
                        <collapsible-card v-for="(gadget, index) in selectedClaim.gadgetDetails" :key="index" class="mt-3">
                            <div slot="title">
                                <h3>{{'Gadget ' + (index + 1)}}</h3>
                                <p class="text-muted">{{gadget.makeLabel + ' / ' + gadget.modelLabel}} <span v-if="gadget.disabled" class="badge badge-danger">Removed</span></p>
                            </div>


                            <div slot="body">
                                <hr />
                                <div class="row">
                                    <div class="col">
                                        <gadget-details :claimId="selectedClaim.claimId"
                                                        :incidentTypeParentId="selectedClaim.parentId"
                                                        :insuranceLineId="selectedClaim.insuranceLineId"
                                                        :gadget="gadget"
                                                        :totalGadgets="selectedClaim.gadgetDetails.Count"
                                                        :claimApproved="selectedClaim.approved"
                                                        @remove_clicked="handleRemoveGadgetClick" />
                                    </div>
                                </div>
                            </div>
                        </collapsible-card>
                    </div>
                </b-tab>
                <!-- Repairs / Replacements -->
                <b-tab title="Repairs / Replacements">
                    <claim-repair-option-list :key="'claim-repair-option-list-top'" v-if="selectedClaim" :reload="claimRepairOptionListVisible" />
                </b-tab>
                <!-- Messages -->
                <b-tab title="Messages">
                    <claim-messages v-if="selectedClaim" :claimId="selectedClaim.claimId" :claimReference="selectedClaim.claimReference" />
                </b-tab>
                <!-- Documents -->
                <b-tab title="Documents">
                    <claim-document-tabs v-if="selectedClaim" :claimId="selectedClaim.claimId" :load="tabIndex==4" />
                </b-tab>
                <!-- Excess -->
                <b-tab title="Excess">
                    <b-tabs card>
                        <!-- Excess Calculations -->
                        <b-tab title="Excess Calculations" active>
                            <claim-excess-calc-list v-if="selectedClaim" :claimId="selectedClaim.claimId" :load="tabIndex==5" />
                        </b-tab>
                        <!-- Excess Payments -->
                        <b-tab title="Excess Payments">
                            <claim-excess-payments-list v-if="selectedClaim" :claimId="selectedClaim.claimId" :load="tabIndex==5" />
                        </b-tab>
                    </b-tabs>
                </b-tab>
                <!-- Bank Details-->
                <b-tab title="Bank Details">
                    <bank-details v-if="selectedClaim" :claimId="selectedClaim.claimId" :claimantName="claimantFullname" :load="tabIndex==6"></bank-details>
                </b-tab>
                <!-- Claim Payments-->
                <b-tab title="Claim Payments" :disabled="!claimPaymentsEnabled">
                    <claim-payments v-if="selectedClaim" :claimId="selectedClaim.claimId" :load="tabIndex==7"></claim-payments>
                </b-tab>
                <!-- Validations -->
                <b-tab title="Validations" >
                    <claim-validations v-if="selectedClaim" />
                </b-tab>
            </b-tabs>
</b-card>

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>

    import PageHeader from '@/components/PageHeader.vue'
    import SimpleDisplayGrid from '@/components/SimpleDisplayGrid.vue'
    import DataList from '@/components/DataList.vue'
    import ClaimApprovePopoutTabs from '@/components/ClaimApprovePopoutTabs.vue'
    import RequestMoreDocs from '@/components/RequestMoreDocs.vue'
    //import PageSize from '@/components/PageSize.vue'
    //import OrderBy from '@/components/OrderBy.vue'
    import PolicyCoverLimits from '@/components/PolicyCoverLimits.vue'
    import PolicyExcessInfo from '@/components/PolicyExcessInfo.vue'
    import PolicyOther from '@/components/PolicyOther.vue'

    import CollapsibleCard from '@/components/CollapsibleCard.vue'
    import CollapsibleCardButtons from '@/components/CollapsibleCardButtons.vue'
    import ClaimGadgetExcess from '@/components/ClaimGadgetExcess.vue'
    import GadgetOptions from '@/components/GadgetOptions.vue'
    import ClaimExcess from '@/components/ClaimExcess.vue'
    import PolicyDetails from '@/components/PolicyDetails.vue'
    import ClaimUser from '@/components/ClaimUser.vue'

    import ClaimRepairOptionList from '@/components/ClaimRepairOptionList.vue'
    import ClaimExcessPaymentsList from '@/components/ClaimExcessPaymentsList.vue'
    import ClaimExcessCalcList from '@/components/ClaimExcessCalcList.vue'
    import GadgetDetails from '@/components/GadgetDetails.vue'

    import { personalDetailsInputs } from '@/ui.config/inputs/personalDetailsInputs'
    import { gadgetDetailsInputs0, gadgetDetailsInputs1, gadgetDetailsInputs2, gadgetDetailsInputs3, gadgetDetailsInputs4 } from '@/ui.config/inputs/gadgetDetailsInputs'
    import { claimDetailsInputs } from '@/ui.config/inputs/claimDetailsInputs'
    import { tripDetailsInputs } from '@/ui.config/inputs/tripDetailsInputs'
    import { selectedPipelineHistoryInputs } from '@/ui.config/inputs/selectedPipelineHistoryInputs'
    import { selectedExcessPaymentInputs } from '@/ui.config/inputs/selectedExcessPaymentInputs'
    import { selectedOnsiteBookingInputs } from '@/ui.config/inputs/selectedOnsiteBookingInputs'

    import { excessPaymentsCols } from '@/ui.config/cols/excessPaymentsCols'
    import { excessCalculationCols } from '@/ui.config/cols/excessCalculationCols'
    import { pipelineHistoryCols } from '@/ui.config/cols/pipelineHistoryCols'
    import { repairsCols } from '@/ui.config/cols/repairsCols'
    import { selectedPipelineHistoryCols } from '@/ui.config/cols/selectedPipelineHistoryCols'
    import { onsiteBookingCols } from '@/ui.config/cols/onsiteBookingCols'
    import { bankDetailsCols } from '@/ui.config/cols/bankDetailsCols'
    import { claimStatusHistoryCols } from '@/ui.config/cols/claimStatusHistoryCols'
    import { claimEmailHistoryCols } from '@/ui.config/cols/claimEmailHistoryCols'
    import { taskHistoryDetailsCols } from '@/ui.config/cols/taskHistoryDetailsCols'
    import { claimNotesCols } from '@/ui.config/cols/claimNotesCols'

    import { flatten } from '@/util/flatten'
    import { mapActions, mapGetters } from 'vuex'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import ClaimNote from '@/components/ClaimNote.vue'

    import { trueFalseToYesNo } from '@/util/formatters'
    let ifReasonIdGreaterThanZero = (obj) => { return obj.reasonId > 0 }

    import authentication from '@/mixins/authentication.js'

    import { runCanApproveClaimPipeline } from '@/util/pipelines/runCanApproveClaimPipeline.js'
    import { runCanDeclineClaimPipeline } from '@/util/pipelines/runCanDeclineClaimPipeline.js'
    import { runClaimWarningsPipeline } from '@/util/pipelines/runClaimWarningsPipeline.js'
    import { runClaimantComparePipeline } from '@/util/pipelines/runClaimantComparePipeline.js'

    import ClaimNotificationsButton from "@/components/ClaimNotificationsButton.vue";

    import ClaimPayments from "@/components/ClaimPayments.vue"
    import ClaimBankDetails from "@/components/ClaimBankDetails.vue"
    import ClaimValidations from "@/components/ClaimValidations.vue"

    import WindowPortal from '@/components/WindowPortal.vue'

    export default {
        name:'ClaimQuickApprove',
        components: {
            PageHeader,
            SimpleDisplayGrid,
            DataList,
            ClaimApprovePopoutTabs,
            RequestMoreDocs,
            Loading,
            ClaimRepairOptionList,
            ClaimExcessPaymentsList,
            ClaimExcessCalcList,
            'claim-notes': ClaimNote,
            'collapsible-card': CollapsibleCard,
            'collapsible-card-buttons': CollapsibleCardButtons,
            'claim-excess': ClaimExcess,
            'policy-details': PolicyDetails,
            'gadget-options': GadgetOptions,
            'claim-user': ClaimUser,
            'gadget-details': GadgetDetails,
            'policy-cover-limits': PolicyCoverLimits,
            'policy-excess-info': PolicyExcessInfo,
            'policy-other-info': PolicyOther,
            'claim-notifications-button': ClaimNotificationsButton,
            'claim-payments': ClaimPayments,
            'bank-details': ClaimBankDetails,
            'claim-validations': ClaimValidations,
            'window-portal': WindowPortal
        },
        mixins: [
            authentication,
        ],
        data: () => {
            return {

                noteCompData: {
                    pageSize: 1,
                    selectedOrderBy: {},
                    orderByOptions: [],
                    selectedNote: {},
                    showAdd: false,
                    newNote: {
                        title: null,
                        body: null
                    }
                },

                otherEmailData: {
                    subject: null,
                    message: null
                },

                // TEST
                selected: [], // Must be an array reference!
                options: [
                    { text: 'Updated EVO with claim details and added Reference', value: '1000' },
                    { text: 'Updated EVO with supporting documents', value: '1001' },
                    { text: 'Updated EVO with repair paperwork', value: '1002' },
                    { text: 'Updated EVO with selected repair option details', value: '1003' }
                ],

                isReportPopped: false,
                reportWindow: null,

                personalDetailsInputs: personalDetailsInputs,
                gadgetDetailsInputs0: gadgetDetailsInputs0,
                gadgetDetailsInputs1: gadgetDetailsInputs1,
                gadgetDetailsInputs2: gadgetDetailsInputs2,
                gadgetDetailsInputs3: gadgetDetailsInputs3,
                gadgetDetailsInputs4: gadgetDetailsInputs4,
                claimDetailsInputs: claimDetailsInputs,
                tripDetailsInputs: tripDetailsInputs,
                selectedOnsiteBookingInputs: selectedOnsiteBookingInputs,
                repairsCols: repairsCols,
                selectedPipelineHistoryCols: selectedPipelineHistoryCols,
                selectedPipelineHistoryInputs: selectedPipelineHistoryInputs,
                selectedExcessPaymentInputs: selectedExcessPaymentInputs,
                onsiteBookingCols: onsiteBookingCols,
                excessCalculationCols: excessCalculationCols,
                bankDetailsCols: bankDetailsCols,
                claimStatusHistoryCols: claimStatusHistoryCols,
                claimEmailHistoryCols: claimEmailHistoryCols,
                taskHistoryDetailsCols: taskHistoryDetailsCols,
                claimNotesCols: claimNotesCols,

                claimOverviewInputs: [
                {
                    id: 'insuranceLineName',
                    label: 'Insurance Line',
                    type: 'text',
                    placeholder: 'Insurance Line',
                        dataPath: 'insuranceLineName'
                },
                {
                    id: 'resellerName',
                    label: 'Reseller',
                    type: 'text',
                    placeholder: 'Reseller',
                    dataPath: 'resellerName'
                },
                {
                    id: 'countryCode',
                    label: 'Country',
                    type: 'text',
                    placeholder: 'Country',
                    dataPath: 'countryCode'
                },
                {
                    id: 'productName',
                    label: 'Product',
                    type: 'text',
                    placeholder: 'Product',
                    dataPath: 'policyDetails.deserialisedObject.productName'
                },
                {
                    id: 'claimReference',
                    label: 'Claim Reference',
                    type: 'text',
                    placeholder: 'Claim Reference',
                    dataPath: 'claimReference',
                    copy: true
                },
                {
                    id: 'relatedReference',
                    label: 'Related Reference',
                    type: 'text',
                    placeholder: 'Related Reference',
                    dataPath: 'relatedReference',
                    copy: true
                },
                {
                    id: 'number',
                    label: 'Policy Number',
                    type: 'text',
                    placeholder: 'Policy Number',
                    dataPath: 'number',
                    copy: true
                },
                {
                    id: 'claimType',
                    label: 'Claim Type',
                    type: 'text',
                    placeholder: 'Claim Type',
                    dataPath: 'claimType'
                },
                {
                    id: 'claimDecision',
                    label: 'Claim Decision',
                    type: 'text',
                    placeholder: 'Claim Decision',
                    dataPath: 'claimDecision'
                },
                {
                    id: 'reasonLabel',
                    label: 'Reason',
                    type: 'text',
                    placeholder: 'Reason declined',
                    dataPath: 'reasonLabel',
                    visible: ifReasonIdGreaterThanZero
                },
                {
                    id: 'claimStatus',
                    label: 'Claim Status',
                    type: 'text',
                    placeholder: 'Claim Status',
                    dataPath: 'claimStatus'
                },
                {
                    id: 'incidentDate',
                    label: 'Incident Date',
                    type: 'text',
                    placeholder: 'Incident Date',
                    dataPath: 'incidentDate'
                },
                {
                    id: 'dateCreated',
                    label: 'Submitted Date',
                    type: 'text',
                    placeholder: 'Submitted Date',
                    dataPath: 'dateCreated'
                },
                {
                    id: 'otherClaims',
                    label: 'Other Claims (last 2 years)',
                    type: 'text',
                    placeholder: 'Other Claims',
                    dataPath: 'otherClaims',
                    customFormatter: trueFalseToYesNo
                    },
                    {
                        id: 'isRenewal',
                        label: 'Is Renewal',
                        type: 'text',
                        placeholder: 'Is Renewal',
                        dataPath: 'isRenewal',
                        customFormatter: trueFalseToYesNo
                    },
                    {
                        id: 'previousQuote',
                        label: 'Previous Policy Number',
                        type: 'text',
                        placeholder: 'Previous Policy Number',
                        dataPath: 'previousQuoteLabel',
                        copy: true
                    }],

                selectedItem: null,

                pageHeader: {
                    title: 'Claim'
                },

                currentPage: 0,

                excessPaymentsCols: excessPaymentsCols,
                pipelineHistoryCols: pipelineHistoryCols,

                selectedPipelineHistory: null,
                selectedPipelineHistoryRules: null,

                selectedExcessPayment: null,

                selectedOnsiteBooking: null,

                selectedExcessCalculation: null,

                selectedEmailHistoryItem: null,

                updatedRelatedRef: null,
                updatedStatus: null,

                sendApprovedEmail: false,

                selectedDeclinationReason: null,
                sendDeclinedEmail: false,

                reason: '',
                moreDocumentationReason: '',
                selectedDocumentTypes: [],

                approvalReason: null,
                approvalIncludeLink: false,

                collapsed: false, //TODO

                pipelineResult: null,
                warningPipelineResult: null,

                tabIndex: 0,
                tab2Index: 0, // Overview / Approve sub tabs
                claimRepairOptionListVisible: false,

                policyPortal: true
            }
        },
        watch: {
            'selectedClaim': function (newVal, oldVal) {
                
                if (this.selectedClaim && newVal) {
                    this.warningPipelineResult = null
                    this.loadDocsAndXsCalculationsAndPayments()
                            .then(response => {
                                this.warningPipelineResult = runClaimWarningsPipeline(this.selectedClaim)
                            })

                    if (this.tabIndex == 1)
                        this.fetchGadgetsForClaim(this.selectedClaim.claimId)
                }
            },
            'tabIndex': function (newVal) {
                console.log('Tab: ' + newVal)
                if (newVal == 1) {
                    // Get gadgets for claim....
                    this.loadGadgetDetails()
                }

                if (newVal == 2) {
                    this.loadGadgetDetails()
                    this.claimRepairOptionListVisible = true
                } else {
                    this.claimRepairOptionListVisible = false
                }
            },
            'tab2Index': function (newVal) {
                console.log('Tab2: ' + newVal)
                if (newVal == 1)
                    this.fetchTaskHistoryForClaim(this.selectedClaim.claimId)
            }
        },
        computed: {
            ...mapGetters({
                policyImported: 'selectedClaimPolicyImported',
                claimMessageUncompletedCount: 'messageStore/claimMessageUncompletedCount',
                claimPaymentsEnabled: 'appSettings/claimPaymentsEnabled'
            }),
            claimId() {
                if (this.selectedClaim) {
                    return parseInt(this.selectedClaim.claimId)
                } else {
                    return -1
                }
            },
            claimantFullname() {
                if (this.selectedClaim) {
                    let { claimantDetails } = this.selectedClaim
                    return claimantDetails.fullname
                }
                return null
            },
            isLoading() {
                return this.$store.getters.isLoading
            },
            selectedClaim() {
                return this.$store.getters.selectedClaim
            },
            selectedClaimExtraFields() {
                if (this.federation) {
                    const extraFields = {
                        federation: this.federation
                    }
                    console.log('-extraFields: ', extraFields)
                    return { ...this.selectedClaim, extraFields }
                } else {
                    return this.selectedClaim
                }
            },
            isTheftOrLoss() {
                return this.selectedClaim.parentId == 1001 || this.selectedClaim.parentId == 1002
            },
            isADOrMB() {
                return this.selectedClaim.parentId == 1000 || this.selectedClaim.parentId == 1003
            },
            emailPreview() {
                return this.$store.getters.emailPreview
            },
            claimsList() {
                return this.$store.getters.claimsList
            },
            documentTypes() {
                return this.$store.getters.documentTypes
            },
            declinationReasons() {
                return this.$store.getters.declinationReasons.map(i => { return { value: i, text: i.label } })
            },
            manualStatuses() {
                return this.$store.getters.manualStatuses.map(i => { return { value: i, text: i.label } })
            },
            documentUrl() {
                return '/api/admin/v1/document/download/'
            },
            routeName() {
                return this.$route.name
            },
            popoutUrl() {
                return this.$store.getters.popoutUrl(this.routeName)
            },
            approvedEmailLastSent() {
                let obj = this.getLatestEmail(1003)
                return obj ? obj.dateCreated : null
            },
            declinedEmailLastSent() {
                let obj = this.getLatestEmail(1004)
                return obj ? obj.dateCreated : null
            },
            requestDocsEmailLastSent() {
                let obj = this.getLatestEmail(1005)
                return obj ? obj.dateCreated : null
            },
            claimPaymentEmailLastSent() {
                let obj = this.getLatestEmail(1007)
                return obj ? obj.dateCreated : null
            },
            isPolicyholder() {
                let { selectedClaim } = this
                if (selectedClaim) {
                    let { claimantDetails } = selectedClaim
                    if (claimantDetails) {
                        if (claimantDetails) {
                            return claimantDetails.policyholder
                        }
                    }
                }
                return false
            },
            taskOptions() {
                return [
                    { text: 'Updated EVO with claim details and added Reference', value: '1000' },
                    { text: 'Updated EVO with supporting documents', value: '1001' },
                    { text: 'Updated EVO with repair paperwork', value: '1002' },
                    { text: 'Updated EVO with selected repair option details', value: '1003' },
                    { text: 'Updated EVO with cancelled repair option details', value: '1004' },
                    { text: 'Update EVO with excess card payment', value: '1005' },
                    { text: 'FT Manually reviewed', value: '1013' }]
            },
            taskOptions2() {
                return this.$store.getters.taskTypesOutstanding
            },
            selectedClaimIndex() {
                return this.$store.getters.selectedClaimIndex
            },
            selectedClaimIndexDisplay() {
                return this.$store.getters.selectedClaimIndex + 1
            },
            claimsListCount() {
                return this.$store.getters.claimsList ? this.$store.getters.claimsList.length : 0
            },
            policyDetails() {
                return this.selectedClaim.policyDetails
            },
            userDetails() {
                return this.selectedClaim.userDetails
            },
            pipelineRuleResults() {
                if (this.pipelineResult) {
                    return this.pipelineResult.ruleResults.filter(r => r.message != null)
                }
                return []
            },
            warningPipelineRuleResults() {
                if (this.warningPipelineResult) {
                    return this.warningPipelineResult.ruleResults.filter(r => r.message != null)
                }
                return []
            },
            claimantComparePipelineRuleResults() {
                let result = runClaimantComparePipeline(this.selectedClaim)
                if (result) {
                    let failures = result.ruleResults.filter(r => r.message != null)
                    if (failures && failures.length > 0)
                        return failures
                }
                return null;
            },
            selectedClaimReference() {
                if (this.selectedClaim) {
                    return this.selectedClaim.claimReference
                } else {
                    return null
                }
            },
            pageHeaderTitle() {
                if (this.selectedClaimReference) {
                    return this.pageHeader.title + ' ' + this.selectedClaimReference
                } else {
                    return this.pageHeader.title
                }
            },
            claimOverviewInputsEx() {
                if (this.selectedClaim) {
                    if (this.selectedClaim.policyDetails) {
                        if (this.selectedClaim.policyDetails.deserialisedObject && this.federations) {
                            if (this.selectedClaim.policyDetails.deserialisedObject.federationId) {
                                const arr = [...this.claimOverviewInputs]
                                const arr2 = [...arr.slice(0, 2),
                                {
                                    id: 'federationName',
                                    label: 'Federation',
                                    type: 'text',
                                    placeholder: 'Federation',
                                    dataPath: 'extraFields.federation'
                                },
                                ...arr.slice(2)]
                                return arr2
                            }
                        }
                    }
                }
                return this.claimOverviewInputs
            },
            federations() {
                return [{ id: 1, label: 'Avon and Somerset Police Federation' },
                { id: 5, label: 'City of London Police Federation' },
                { id: 6, label: 'Cleveland Police Federation' },
                { id: 9, label: 'Devon and Cornwall Police Federation' },
                { id: 11, label: 'Durham Police Federation' },
                { id: 13, label: 'Essex Police Federation' },
                { id: 17, label: 'Hampshire Police Federation' },
                { id: 18, label: 'Hertfordshire Police Federation' },
                { id: 20, label: 'Kent Police Federation' },
                { id: 25, label: 'Metropolitan Police Federation' },
                { id: 27, label: 'Norfolk Police Federation' },
                { id: 34, label: 'Staffordshire Police Federation' },
                { id: 35, label: 'Suffolk Police Federation' },
                { id: 37, label: 'Sussex Police Federation' },
                { id: 41, label: 'West Midlands Police Federation' },
                { id: 44, label: 'British Transport Police Federation' },
                { id: 45, label: 'George Burrows GIS Staff Scheme' }]
            },
            federation() {
                try {
                    if (this.policyDetails.deserialisedObject && this.federations) {
                        if (this.policyDetails.deserialisedObject.federationId) {
                            let fed = this.federations.find(f => f.id == this.policyDetails.deserialisedObject.federationId)
                            console.log('-fed: ', fed)
                            return fed.label
                        }
                    }
                    return null
                } catch {
                    return null
                }
            },
        },
        async mounted() {
            this.fetchDocumentTypes()
            this.fetchDeclinationReasons()
            this.fetchManualStatuses()
            //const response = await this.loadXsCalcsAndPayments()
            //console.log('-r: ', response)
        },
        methods: {
            ...mapActions([
                'updateClaimRelatedRef',
                'approveClaim',
                'approveClaimPreview',
                'declineClaim',
                'declineClaimEmailPreview',
                'resetEmailPreview',
                'fetchDocumentTypes',
                'fetchDeclinationReasons',
                'fetchManualStatuses',
                'requestMoreDocs',
                'refreshClaimantForClaim',
                'updateClaimTaskFlags',
                'addClaimNote',
                'otherEmailPreview',
                'sendOtherEmail',
                'claimPaymentEmailPreview',
                'sendClaimPaymentEmail',
                'setSelectedClaimIndex',
                'fetchSelectedClaim',
                'fetchTaskTypesOutstanding',
                'fetchPolicyClaim',
                'fetchUserClaim',
                'fetchSalesDocumentUploads',
                'fetchSelectedClaimEx',
                'disableGadgetForClaim',
                'fetchOptionsPreviewForGadget',
                'fetchGadgetsForClaim',
                'fetchTaskHistoryForClaim',
                'fetchExcessPaymentsClaim',
                'fetchExcessCalculationsClaim',
                'fetchDocumentsClaim2'
            ]),
            ...mapActions({ checkUserExists: 'formUser/checkUserExists' }),
            loadClaimDetails() {
                let { claimReference, claimId, insuranceLineId, policyId, userId } = this.selectedClaim
                this.fetchPolicyClaim({ insuranceLineId, policyId })
                this.fetchUserClaim({ userId })
                this.fetchTaskTypesOutstanding(claimId)
                this.otherEmailData.subject = 'Your claim: ' + claimReference

                if (this.policyImported) {
                    let { resellerId, claimantDetails } = this.selectedClaim
                    let { email } = claimantDetails
                    this.checkUserExists({ resellerId, emailAddress: email })
                }

                this.fetchSalesDocumentUploads(this.selectedClaim.number)
                this.warningPipelineResult = runClaimWarningsPipeline(this.selectedClaim)
            },
            loadGadgetDetails() {
                if (this.selectedClaim) {
                    if (!this.selectedClaim.gadgetDetails || this.selectedClaim.gadgetDetails.length == 0) {
                        this.fetchGadgetsForClaim(this.selectedClaim.claimId)
                    }
                }
            },
            async loadDocsAndXsCalculationsAndPayments() {
                try {
                    const documents = await this.loadDocuments()
                    const xs = await this.loadXsCalcsAndPayments()

                    const rs = { ...documents, ...xs }
                    
                    return new Promise((resolve, reject) => {
                        resolve(rs)
                    })

                } catch (error) { console.log('loadDocsAndXsCalculationsAndPayments - error: ', error) }
            },
            async loadDocuments() {
                try {
                    let { claimId } = this.selectedClaim

                    let ordering = null

                    let pages = {
                        pageSize: 10,
                        pageNumber: 1
                    }

                    let criteria = {
                        claimId,
                        ...pages,
                        ...ordering
                    }

                    const documents = await this.fetchDocumentsClaim2(criteria)
                    return new Promise((resolve, reject) => {
                        resolve({ x: documents })
                    })

                } catch (error) {
                    console.log('loadDocuments - error: ', error)
                }
            },
            async loadXsCalcsAndPayments() {

                try {
                    let payload = {
                        id: this.selectedClaim.claimId,
                        ignoreTaskFlag: true,
                        pageSize: 10,
                        pageNumber: 1,
                        orderBy: "CardPaymentDate",
                        sortDirection: "DESC"
                    }
                    const xsPayments = await this.fetchExcessPaymentsClaim(payload)
                    const xsCalculations = await this.fetchExcessCalculationsClaim(this.selectedClaim.claimId)

                    return new Promise((resolve, reject) => {
                        resolve({ xsCalculations: xsCalculations.data, xsPayments: xsPayments.data })
                    })
                } catch (error) {
                    console.log('loadXsCalcsAndPayments - error: ', error)
                }
            },
            gadgetPolicyholderPossession(gadget) {
                return gadget.policyholderPossession
            },
            handlePageHeaderButtonClick (button) {
                if (button) {
                    this.$refs.claimSaveModal.show()
                }
            },
            handlePopoutClick () {
                let url = this.popoutUrl
                this.reportWindow = window.open(url, '_blank');

                var watch = setInterval(() => {
                    if(this.reportWindow.closed) {
                        clearInterval(watch);
                        this.isReportPopped = false;
                    }
                }, 500);

                this.isReportPopped = true;
            },
            handleHistoryItemDblClick(payload) {
                this.selectedPipelineHistory = payload
                let { result } = this.selectedPipelineHistory
                result = JSON.parse(result)
                this.selectedPipelineHistoryRules = []
                for (let i = 0; i < result.length; i++) {
                    this.selectedPipelineHistoryRules.push(flatten(result[i]))
                }
            },
            handleExcessPaymentItemDblClick(payload) {
                this.selectedExcessPayment = payload
            },
            handleOnsiteBookingItemDblClick(payload) {
                this.selectedOnsiteBooking = payload
            },
            handleExcessCalculationItemDblClick(payload) {
                this.selectedExcessCalculation = payload
            },
            handleEmailHistoryItemDblClick(payload) {
                this.selectedEmailHistoryItem = payload
            },
            handleUpdateRelatedRefClick() {
                let { updatedRelatedRef, updatedStatus, selectedDeclinationReason } = this
                let { claimId, claimRowVersion } = this.selectedClaim

                this.selectedDeclinationReason = null
                this.updatedStatus = null
                this.updatedRelatedRef = null

                let noPipeline = true

                if (updatedStatus && updatedStatus.id == 1009) {
                    this.pipelineResult = runCanApproveClaimPipeline(this.selectedClaim)
                    noPipeline = false
                }

                if (updatedStatus && updatedStatus.id == 1024) {
                    this.pipelineResult = runCanDeclineClaimPipeline(this.selectedClaim)
                    noPipeline = false
                }

                if (noPipeline || (this.pipelineResult && this.pipelineResult.success == true)) {
                    this.updateClaimRelatedRef(
                        {
                            claimId,
                            rowVersion: claimRowVersion,
                            relatedReference: updatedRelatedRef,
                            statusId: updatedStatus ? updatedStatus.id : null,
                            reasonId: selectedDeclinationReason ? selectedDeclinationReason.id : null
                        })
                    this.pipelineResult = null
                }
            },
            handleUpdateFlagsClick() {
                let { selected } = this
                let { claimId } = this.selectedClaim

                this.updateClaimTaskFlags(
                    {
                        claimId,
                        taskFlags: selected
                    }
                )
            },
            handleApproveclaimClick() {
                let { claimId } = this.selectedClaim
                let { approvalReason: messageText, approvalIncludeLink: includeRepairOptionsLink } = this

                this.approveClaim({
                    claimId,
                    messageText,
                    includeRepairOptionsLink
                })

                this.approvalReason = null
                this.approvalIncludeLink = false
            },
            handleApproveclaimPreviewClick() {
                this.resetEmailPreview()
                let { claimId } = this.selectedClaim
                let { approvalReason: messageText, approvalIncludeLink: includeRepairOptionsLink } = this

                this.approveClaimPreview({
                    claimId,
                    messageText,
                    includeRepairOptionsLink
                })

                this.$nextTick(() => {
                    this.$bvModal.show('previewEmailModal')
                })

            },
            handleDeclineclaimClick() {
                let { claimId } = this.selectedClaim
                let { reason, selectedDeclinationReason } = this
                let sendEmail = this.sendDeclinedEmail

                this.declineClaim({
                    claimId,
                    reason: selectedDeclinationReason ? selectedDeclinationReason.id : null,
                    messageText: reason,
                    sendEmail
                })
            },
            handleDeclineclaimPreviewClick() {
                this.resetEmailPreview()
                let { claimId } = this.selectedClaim
                let { reason, selectedDeclinationReason } = this
                let sendEmail = this.sendDeclinedEmail

                this.declineClaimEmailPreview({
                    claimId,
                    reason: selectedDeclinationReason ? selectedDeclinationReason.id : null,
                    messageText: reason,
                    sendEmail
                })

                this.$nextTick(() => {
                    this.$bvModal.show('previewEmailModal')
                })
                
            },
            handleOtherPreviewClick() {
                this.resetEmailPreview()
                let { claimId } = this.selectedClaim
                let { otherEmailData } = this

                this.otherEmailPreview({
                    claimId,
                    ...otherEmailData
                })

                this.$nextTick(() => {
                    this.$bvModal.show('previewEmailModal')
                })

            },
            handleOtherClick() {
                this.resetEmailPreview()
                let { claimId } = this.selectedClaim
                let { otherEmailData } = this

                this.sendOtherEmail({
                    claimId,
                    ...otherEmailData
                })

                this.otherEmailData = { subject: null, message:null }

            },
            handleClaimPaymentPreviewClick() {
                this.resetEmailPreview()
                let { claimId } = this.selectedClaim

                this.claimPaymentEmailPreview({
                    claimId
                })

                this.$nextTick(() => {
                    this.$bvModal.show('previewEmailModal')
                })

            },
            handleClaimPaymentClick() {
                this.resetEmailPreview()
                let { claimId } = this.selectedClaim

                this.sendClaimPaymentEmail({
                    claimId
                })

                this.otherEmailData = { subject: null, message:null }

            },
            handleRequestMoreDocsClick() {
                this.$bvModal.show('previewEmailModal')
            },
            getBlobURL(code, type) {
                const blob = new Blob([code], { type })
                return URL.createObjectURL(blob)
            },
            handleDocumentTypeClick(item) {
                if (this.selectedDocumentTypes.includes(item)) {
                    this.selectedDocumentTypes.splice(this.selectedDocumentTypes.indexOf(item), 1)
                } else {
                    this.selectedDocumentTypes.push(item)
                }
            },
            getLatestEmail(typeId) {
                let { emailHistoryDetails } = this.selectedClaim
                if (emailHistoryDetails) {
                    let emails = typeId ? emailHistoryDetails.filter(email => email.emailTypeId == typeId) : emailHistoryDetails
                    
                    let maxDate = Math.max.apply(null, emails.map((e) => {
                        return new Date(e.dateCreated);
                    }));
                    let latest = emails.filter(a => { let dte = new Date(a.dateCreated).getTime(); return dte == maxDate; })
                    return latest[0]
                }
            },
            claimHasStatus(statusId) {
                let { claimStatusDetails } = this.selectedClaim
                if (claimStatusDetails) {
                    return claimStatusDetails.filter(o => o.statusId == statusId).length > 0
                }
                return false
            },
            handleRefreshClaimantClick() {
                let { claimId } = this.selectedClaim
                this.refreshClaimantForClaim(claimId)
            },
            handleClaimNavClick(payload) {
                this.setSelectedClaimIndex(this.selectedClaimIndex + payload)
                this.fetchSelectedClaimEx(this.claimsList[this.selectedClaimIndex].claimId)
            },
            handleRemoveGadgetClick(payload) {
                console.log(payload)
                this.disableGadgetForClaim(payload)
            },
            handlePaginationInput(payload) {
              let params = {};

              if (this.claimId) {
                params.claimId = this.claimId;
              } else {
                params.withoutClaim = true;
              }
              params.pageNumber = payload;

              this.loadMessages(params)
                .then()
                .catch(error => console.log("error2: ", error))
                .finally(() => {
                  console.log("all done!");
                });
            },
            handlePreviewOptionsForGadgetClick(gadgetWebReference) {
                this.fetchOptionsPreviewForGadget(gadgetWebReference)
            }
        }
    }
    </script>

    <style>
        .fade-enter-active, .fade-leave-active {
            transition: opacity .5s;
        }

        .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
            opacity: 0;
        }

        pre {
            outline: 1px solid #ccc;
            padding: 5px;
            margin: 5px;
        }

        .string {
            color: green;
        }

        .number {
            color: darkorange;
        }

        .boolean {
            color: blue;
        }

        .null {
            color: magenta;
        }

        .key {
            color: red;
        }
    </style>

